import { createBrowserRouter } from 'react-router-dom'
import type { ReactNode } from 'react'
import { LoadingGate } from '@/components/LoadingGate'
import { Landing } from '@/pages/Landing'
import { KitchenSink } from '@/pages/KitchenSink'
import {
  DirectionsStub,
  HistoryStub,
  TestStub,
  TrackingCopyStub,
} from '@/pages/stubs'
import { Tracking } from '@/pages/Tracking'

/* Port of createRouter (flutter_flow/nav/nav.dart).
 *
 * Flat route table, path-URL strategy, initialLocation '/'. NO redirects
 * exist in the original: no route sets requireAuth, so the auth branch of
 * FFRoute.redirect is dead code and shouldRedirect is always false.
 *
 * Every FFRoute wraps its page in the loading gate (spinner while
 * user == null || showSplashImage). The 404 errorBuilder does NOT: it
 * renders `loggedIn ? Home : Welcome` directly, with no gate and no
 * transition, and the bad URL STAYS in the address bar. We mirror that with
 * a splat route whose element is an ungated Landing.
 *
 * '/', '/welcome', '/home' and the splat all render the same Landing —
 * WelcomeWidget and HomeWidget are byte-identical, and '_initialize' picks
 * between them by loggedIn, which changes nothing visible. One component.
 *
 * Transitions: the only TransitionInfo in the app is fade with duration
 * 0 ms — visually nothing — so no transition layer is ported. */

function gated(el: ReactNode) {
  return <LoadingGate>{el}</LoadingGate>
}

export const router = createBrowserRouter([
  // '_initialize' — loggedIn ? Home : Welcome (identical -> Landing).
  { path: '/', element: gated(<Landing />) },
  { path: '/welcome', element: gated(<Landing />) },
  { path: '/home', element: gated(<Landing />) },

  // 'Tracking' — the only live screen. :id is an alarms/{id} document id.
  { path: '/app/:id', element: gated(<Tracking />) },

  // Unreachable-in-app routes, kept for URL parity (M10).
  { path: '/history', element: gated(<HistoryStub />) },
  { path: '/directions', element: gated(<DirectionsStub />) },
  { path: '/test', element: gated(<TestStub />) },
  { path: '/trackingCopy', element: gated(<TrackingCopyStub />) },

  // Dev-only design-system page (not in the original app).
  { path: '/kitchen-sink', element: <KitchenSink /> },

  // errorBuilder: ungated, URL untouched.
  { path: '*', element: <Landing /> },
])
